import React from 'react';
import ReactDOM from 'react-dom/client';
import { hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './styles/global.css';
import App from './App';

const rootElement = document.getElementById('root');

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap prerenders static HTML into #root at build time. When that
// prerendered markup is present (real deploys), we hydrate on top of it
// instead of wiping and re-rendering from scratch — this keeps the
// server-rendered content crawlers see intact until React takes over.
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(app);
}
